<ion-content>

	<div class="logo">
		<img src="assets/img/shortcut-icon.png" alt="Shortcut">
	</div>

	<p class="SCWEB-header-text">Let's verify your<br>phone number</p>

	<p id="description-text">Your number will only be contacted if you<br>book one of our stylists.</p>

	<ion-item lines="none">
		<ion-input [(ngModel)]="phone" type="phone" required placeholder="Your phone number (e.g 1231231234)">
		</ion-input>
	</ion-item>

	<ion-button class="SC-long-button" color="marine" (click)="onSendCode()" type="submit" block>
		Send code
	</ion-button>

	<ion-row class="SC-bottom-button-row">
		<ion-col>
			<ion-button class="SC-light-bottom-button" fill="clear" (click)="logout()">Log Out</ion-button>
		</ion-col>
	</ion-row>

</ion-content>